export const validatePassword = (pword) => {
  let count = 0;
  if (pword.toUpperCase() !== pword) count++;
  if (pword.toLowerCase() !== pword) count++;
  if (/\d/.test(pword)) count++;
  if (/[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g.test(pword)) count++;
  return count >= 3;
};
